import loadable from '@loadable/component';

export const RecommendedCandidateDetailPageLoadable = loadable(
  () => import('./RecommendedCandidateDetailPage'),
  {
    resolveComponent: (module) => module.RecommendedCandidateDetailPage,
  },
);
